import { formatNumber } from '../../../helpers/FormatNumber/formatNumber';

const TOOLTIP_ID = 'chartjs-external-tooltip';
const GAP = 12;

const getOrCreateTooltip = () => {
    let el = document.getElementById(TOOLTIP_ID);

    if (!el) {
        el = document.createElement('div');
        el.id = TOOLTIP_ID;
        el.className = 'chartjs-external-tooltip';
        document.body.appendChild(el);
    }

    return el;
};

export const externalTooltipHandler = (context, currencySymbol) => {
    const { tooltip } = context;
    const tooltipEl = getOrCreateTooltip();


    if (!tooltip || tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    const dataPoint = tooltip.dataPoints?.[0];
    if (!dataPoint) return;

    tooltipEl.innerHTML = `
    <div style="font-weight:600; margin-bottom:4px;">
      ${dataPoint.label}
    </div>
    <div>
      ${currencySymbol}${formatNumber(dataPoint.raw || 0)}
    </div>
  `;

    const canvasRect = tooltip.chart.canvas.getBoundingClientRect();

    let x = canvasRect.left + window.pageXOffset + tooltip.caretX + GAP;
    let y = canvasRect.top + window.pageYOffset + tooltip.caretY - GAP;

    const { width, height } = tooltipEl.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;


    if (x + width > vw - GAP) {
        x = canvasRect.left + window.pageXOffset + tooltip.caretX - width - GAP;
    }


    x = Math.max(GAP, x);

    if (y + height > vh - GAP) {
        y = canvasRect.top + window.pageYOffset + tooltip.caretY - height - GAP;
    }

    y = Math.max(GAP, y);

    tooltipEl.style.left = `${x}px`;
    tooltipEl.style.top = `${y}px`;
    tooltipEl.style.opacity = 1;
};

export const destroyExternalTooltip = () => {
    const el = document.getElementById(TOOLTIP_ID);
    if (el) el.remove();
};
